import { TeachingLoadReportType } from '@bp/planung-graphql-types';
import { Table, TableColumns } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';

export type TeachingLoadReportTypesTableType = {
  type: TeachingLoadReportType;
  name: string;
};

type TeachingLoadReportTypesTableProps = {
  data: TeachingLoadReportTypesTableType[];
  onSelect: (type: TeachingLoadReportType, headline: string) => void;
};

export const TeachingLoadReportTypesTable = observer(({ data, onSelect }: TeachingLoadReportTypesTableProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  // Stabile Referenzen: die Tabelle setzt bei neuen columns/rowSelection ihren Zustand zurück.
  const columns: TableColumns<TeachingLoadReportTypesTableType>[] = useMemo(
    () => [
      {
        header: '',
        id: 'name',
        accessorKey: 'name',
        canExpand: true,
      },
    ],
    [],
  );

  const rowSelection = useMemo(() => ({ [selectedIndex]: true }), [selectedIndex]);

  return (
    <Table<TeachingLoadReportTypesTableType>
      hideHeader
      data={data}
      columns={columns}
      onRowClick={(e, row) => {
        setSelectedIndex(parseInt(row.id));
        onSelect(row.original.type, row.original.name);
      }}
      showRowHover
      rowSelection={rowSelection}
      showSelected
      customPadding='var(--spacing-6)'
    />
  );
});
